import { render, staticRenderFns } from "./EntregaDocumentos.vue?vue&type=template&id=21487536"
import script from "./EntregaDocumentos.vue?vue&type=script&lang=js"
export * from "./EntregaDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21487536')) {
      api.createRecord('21487536', component.options)
    } else {
      api.reload('21487536', component.options)
    }
    module.hot.accept("./EntregaDocumentos.vue?vue&type=template&id=21487536", function () {
      api.rerender('21487536', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/EntregaDocumentos.vue"
export default component.exports